import { PromptInputSpeechButton } from '@/ai-elements/prompt-input';
import { ChatInputState, ThemeIconValue } from '@brandclub/bc-widgets';
import { IconMicrophone } from '../ConciergeIcons';
import React from 'react';

interface MicrophoneButtonProps {
  disabled: boolean;
  textareaRef: React.RefObject<HTMLTextAreaElement | null>;
  onChange?: (value: string) => void;
  styles: ChatInputState;
  themeIcons: Record<string, ThemeIconValue>;
  resolveColor: (color: any) => string;
}

export const MicrophoneButton: React.FC<MicrophoneButtonProps> = ({
  disabled,
  textareaRef,
  onChange,
  styles,
  themeIcons,
  resolveColor,
}) => {
  const micIconKey = styles.microphoneIcon;
  const customMicIcon = micIconKey && micIconKey !== 'default' ? themeIcons[micIconKey] : null;

  return (
    <PromptInputSpeechButton
      disabled={disabled}
      textareaRef={textareaRef}
      onTranscriptionChange={onChange}
      aria-label="Voice input"
      className="tw:p-0 tw:bg-transparent! tw:shadow-none! tw:border-none tw:cursor-pointer hover:tw:bg-transparent! disabled:tw:opacity-50 disabled:tw:cursor-not-allowed"
      style={{ width: styles.iconSize, height: styles.iconSize }}
    >
      {(isListening) => (
        <div className="tw:relative tw:cursor-pointer">
          {customMicIcon ? (
            <img
              src={customMicIcon.url}
              alt={customMicIcon.name}
              style={{
                width: styles.iconSize,
                height: styles.iconSize,
                filter: isListening ? `drop-shadow(0 0 2px ${resolveColor(styles.micActiveColor)})` : undefined,
              }}
            />
          ) : (
            <IconMicrophone
              size={styles.iconSize}
              style={{
                color: isListening ? resolveColor(styles.micActiveColor) : resolveColor(styles.iconColor),
                width: styles.iconSize,
                height: styles.iconSize,
              }}
            />
          )}
          {isListening && (
            <span
              className="tw:absolute tw:-top-0.5 tw:-right-0.5 tw:size-2 tw:rounded-full tw:animate-pulse"
              style={{ backgroundColor: resolveColor(styles.micActiveColor) }}
            />
          )}
        </div>
      )}
    </PromptInputSpeechButton>
  );
};
